export class ParishProject {
    ppId: number;
    parishId: number;
    projectId: number;
    status: string;
}
